<ng-template let-item>
    <span class="text-value">
        {{(item === statuses.Active ? 'common.active' : 'common.inactive') | translate}}
    </span>
</ng-template>
